import * as React from "react";

import * as ApolloClient from "@apollo/client";
import logLevel from "loglevel";

import { DataClientProviderProps } from "./types";
import { LoggerImpl } from "~/modules/logger/Logger/LoggerImpl/LoggerImpl";

interface TwilioWindow {
    Twilio?: {
        Flex?: unknown;
    };
}





















export const DataClientProvider = ({ children, dataClient }: DataClientProviderProps): JSX.Element => {
    try {
        const externalApolloInstance = ApolloClient.useApolloClient();
        if (externalApolloInstance) {
            const log = new LoggerImpl(logLevel);
            log.setLevel("WARN");
            if (typeof window !== "undefined" && (window as TwilioWindow)?.Twilio?.Flex) {
                log.warn(
                    "DataClientProvider: Another Apollo Client instance has been detected " +
                        "inside the consuming application.\nIf you have custom Flex UI components " +
                        "that use Apollo Client to call your preferred GraphQL API, follow the steps in " +
                        "[Use Apollo Client with Flex UI](twilio.com/docs/flex/developer/ui/apollo-client) " +
                        "before enabling this feature to avoid this issue."
                );
            }
            log.warn(
                "DataClientProvider: Another Apollo Client instance has been detected inside the consuming application." +
                    "\nThis may lead to unexpected behavior when performing GraphQL operations."
            );
        }
    } catch {
        



    }

    return (
        <>{dataClient && <ApolloClient.ApolloProvider client={dataClient}>{children}</ApolloClient.ApolloProvider>}</>
    );
};

DataClientProvider.displayName = "DataClientProvider";
